import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSliderModule } from '@angular-slider/ngx-slider';

import { AuctionRoutingModule } from './auction-routing.module';

import { SharedModule } from '../shared/shared.module';

import {
    PageAuctionSearchComponent,
    PageManageAuctionFiltersComponent

} from './pages';

import {
    ModalSearchFilterItemComponent,
    ModalSearchFilterItemTextComponent,
    ModalSearchFilterItemChoicesComponent,
    ModalSearchFilterItemRangeComponent,
    ModalViewAuctionImagesComponent
} from './modals';

import {
    AuctionSearchFilterComponent,
    AuctionSearchCardComponent,
    AuctionSearchFilterItemTextComponent,
    AuctionSearchFilterItemChoicesComponent,
    AuctionSearchFilterItemRangeComponent,
    AuctionSearchPaginationComponent,
    AuctionSearchSavedFiltersComponent,
    AuctionSearchFilterShowAllComponent,
    SearchFilterItemChoicesComponent,
    SearchFilterItemRangeComponent,
    SearchFilterItemTextComponent
} from './components';

import {
    AttributeDefinitionService,
    CustomFilterService,
    CountryService,
    RegionService,
    UnitOfMeasureService,
    VarietyService,
    WineCategoryService,
    WineryService,
} from './../services';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        NgSelectModule,
        NgbModule,
        AuctionRoutingModule,
        NgxSliderModule
    ],
    declarations: [
        PageAuctionSearchComponent,
        PageManageAuctionFiltersComponent,
        AuctionSearchFilterComponent,
        AuctionSearchCardComponent,
        AuctionSearchFilterItemTextComponent,
        AuctionSearchFilterItemChoicesComponent,
        AuctionSearchFilterItemRangeComponent,
        ModalSearchFilterItemComponent,
        ModalSearchFilterItemTextComponent,
        ModalSearchFilterItemChoicesComponent,
        ModalSearchFilterItemRangeComponent,
        ModalViewAuctionImagesComponent,
        AuctionSearchPaginationComponent,
        AuctionSearchSavedFiltersComponent,
        AuctionSearchFilterShowAllComponent,
        SearchFilterItemChoicesComponent,
        SearchFilterItemRangeComponent,
        SearchFilterItemTextComponent
    ],
    providers: [
        CustomFilterService,
        CountryService,
        RegionService,
        VarietyService,
        WineryService,
        AttributeDefinitionService,
        WineCategoryService,
        UnitOfMeasureService,
    ],
})
export class AuctionModule {

}